import { ContactMeActions } from '../actions/contactme-action-creators.mjs';

const contactMeReducer = (state, action) => {
  let contactMe = state.contactMe || {
    searchForLocationMatch: true
  };

  switch (action.type) {
    case ContactMeActions.CONTACTME_LEAD_UPDATED: {
      contactMe.contactLead = action.contactLead;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.APPOINTMENT_LOCATION_SEARCH_UPDATED: {
      contactMe.locationSearchForm = action.locationSearchForm;
      break;
    }

    case ContactMeActions.APPOINTMENT_LOCATION_SELECTED: {
      contactMe.selectedLocation = action.location;
      break;
    }

    case ContactMeActions.APPOINTMENT_LOCATIONS_UPDATED: {
      contactMe.searchForLocationMatch = false;
      contactMe.availableLocations = action.availableLocations;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.APPOINTMENT_TIMESLOT_SELECTED: {
      contactMe.selectedTime = action.time;
      break;
    }

    case ContactMeActions.APPOINTMENT_TIMESLOTS_UPDATED: {
      contactMe.availableTimeSlots = action.availableTimeSlots;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.APPOINTMENT_BOOKING_COMPLETE: {
      contactMe.appointment = action.appointment;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.CONTACTME_LEAD_UPDATE_STARTED:
    case ContactMeActions.APPOINTMENT_LOCATIONS_UPDATE_STARTED:
    case ContactMeActions.APPOINTMENT_TIMESLOTS_UPDATE_STARTED:
    case ContactMeActions.APPOINTMENT_BOOKING_STARTED: {
      contactMe.isProcessing = true;
      break;
    }

    default:
      return state;
  }
  return {
    ...state,
    contactMe
  };
};

export default contactMeReducer;
